export default function OrderOnline() {
    return (
      <main style={{maxWidth: 1100, margin: "0 auto", padding: "24px 16px"}}>
        <h1>Order Online</h1>
        <p>Coming soon…</p>
      </main>
    );
  }